import type { DscApplicantSection } from "@credit-acceptance/step6-bff-client";
import { Zap } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useReadOnly } from "../lock/ReadOnlyContext";
import ViewBureauModal from "../viewBureau/ViewBureauModal";
import { downloadDealSummaryPdf } from "./api/downloadDealSummaryPdf";
import FabPopover from "./FabPopover";
import { MOCK_ACTION_ITEMS } from "./mockData";

export const ACTIONS_PANEL_ID = "actions-panel";

type ActionsPopoverProperties = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  approvalId: string;
  /** Driver applicant section from the dashboard response, forwarded to the View Bureau modal. */
  driver: DscApplicantSection | undefined;
  /** 2nd signer applicant section, forwarded to the View Bureau modal. */
  secondSigner: DscApplicantSection | undefined;
};

function ActionsPopover({ open, onOpenChange, approvalId, driver, secondSigner }: ActionsPopoverProperties) {
  const { t } = useTranslation();
  const [viewBureauOpen, setViewBureauOpen] = useState(false);
  const readOnly = useReadOnly();

  const handleActionClick = (actionId: string) => {
    onOpenChange(false);

    if (actionId === "view-bureau") {
      setViewBureauOpen(true);
      return;
    }

    if (actionId === "print-step5") {
      downloadDealSummaryPdf(approvalId);
    }
  };

  return (
    <>
      <FabPopover
        label={t("actions.menu")}
        icon={<Zap className="size-6" />}
        variant="navy"
        panelId={ACTIONS_PANEL_ID}
        open={open}
        onOpenChange={onOpenChange}
        disabled={readOnly}
        contentClassName="w-56 p-1"
      >
        <ul role="menu" aria-label={t("actions.menu")}>
          {MOCK_ACTION_ITEMS.map((item) => (
            <li key={item.id} role="none">
              <button
                type="button"
                role="menuitem"
                className="hover:bg-accent focus-visible:bg-accent text-foreground w-full rounded-sm px-3 py-2 text-left text-sm outline-none transition-colors"
                onClick={() => handleActionClick(item.id)}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </FabPopover>
      <ViewBureauModal
        open={viewBureauOpen}
        onOpenChange={setViewBureauOpen}
        approvalId={approvalId}
        driver={driver}
        secondSigner={secondSigner}
      />
    </>
  );
}

export default ActionsPopover;
